import React from 'react';
import { useLanguage } from '../LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-sm font-medium"
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <Globe size={18} />
      <span className="hidden sm:inline">
        {language === 'en' ? 'ES' : 'EN'}
      </span>
      <span className="inline sm:hidden">
        {language === 'en' ? '🇪🇸' : '🇺🇸'}
      </span>
    </button>
  );
};

export default LanguageToggle;
